import { zodResolver } from "@hookform/resolvers/zod";
import TextInput from "components/app/function/TextInput";
import { Form, FormControl, FormField, FormItem, FormMessage } from "components/ui/form";
import { useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { AppLog } from "services";
import { RequestApi, RouteApi, RouteUrl, StatusMsg } from "utils";
import { z } from "zod";

export default function RequestDeleteAccount() {
  const [textValidate, setTextValidate] = useState(null);
  const navigate = useNavigate();

  const FormSchema = z.object({
    email: z.string().min(1, { message: "Email is required*" }).email({ message: "Invalid email address format*" }),
  });

  const form = useForm<z.infer<typeof FormSchema>>({
    resolver: zodResolver(FormSchema),
    defaultValues: {
      email: "",
    },
  });

  const onSubmit = async (data: z.infer<typeof FormSchema>) => {
    try {
      let url: string = "";
      url = RouteApi.submitRequestDeleteAccount;

      const dataAPI = {
        email: data.email,
      };

      const response = await RequestApi(url, { data: dataAPI });
      if (response.status === "success") {
        navigate(
          `${RouteUrl.receiveRequestFeedback}?title=Request Account Deletion&description=We received your request to delete account, our team will process it within 7 business days. Please note that account deletion is permanent and cannot be undone. If you have any questions or need assistance, send email to support@maxx4business.com, feel free to reach out before proceeding.`
        );
      } else {
        setTextValidate(response["msg"]);
        AppLog.show({ message: response.msg, status: StatusMsg.getType(response.status) });
      }
    } catch (error) {
      AppLog.show({
        message: `[onSubmit]`,
        status: StatusMsg.error,
        error,
      });
    }
  };

  return (
    <Form {...form}>
      <form onSubmit={form.handleSubmit(onSubmit)}>
        <div className="flex justify-center items-center min-h-screen bg-gray-50">
          <div className="flex justify-center p-6 bg-white rounded-lg shadow-lg">
            <div className="max-w-lg w-full space-y-8 text-center">
              <h1 className="text-3xl md:text-5xl lg:text-6xl font-sans text-gray-700 font-light">Support Center</h1>
              <h2 className="font-semibold text-xl md:text-3xl lg:text-4xl text-blue-600">Request Account Deletion</h2>
              <p className="text-gray-600">If you wish to delete your account, please input your email address associated with your account.</p>
              <p className="text-gray-600">
                Once we receive your request, our team will process it within 7 business days. Please note that account deletion is permanent and cannot be undone. If you have any
                questions or need assistance, feel free to reach out before proceeding.
              </p>

              <FormField
                control={form.control}
                name="email"
                render={({ field }) => (
                  <FormItem>
                    <FormControl>
                      <TextInput
                        placeholder="Please input your email here..."
                        {...field}
                        className="w-full border border-gray-300 rounded-md px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                      />
                    </FormControl>
                    <FormMessage className="text-red-500 mt-2 text-sm" />
                  </FormItem>
                )}
              />

              <button type="submit" className="bg-blue-500 text-white px-6 py-2 rounded-md font-medium w-full hover:bg-blue-600 transition duration-200">
                Send
              </button>

              {textValidate && <p className="text-sm md:text-lg text-red-600 font-light">{textValidate}</p>}
            </div>
          </div>
        </div>
      </form>
    </Form>
  );
}
